import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Generated class for the SearchBreweryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-search-brewery',
  templateUrl: 'search-brewery.html',
  styleUrls: ['./search-brewery.scss'],
  standalone: false,
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    TranslateModule
  ]
})
export class SearchBreweryPage {
  public static PATH: string = 'searchbrewery';

  constructor(public viewCtrl: ModalController) {
  }

  close() {
    this.viewCtrl.dismiss();
  }
}
